import { createFilterAtoms } from '@/common/filtering/store.ts';
import {
  DEFAULT_ASSET_FILTER,
  type AssetFilterDefinition,
} from '@pac/filter/shared/assets';
import { resetAssetPaginationOnFilterChangeAtom } from './pagination.ts';

export const assetFilterAtoms = createFilterAtoms<AssetFilterDefinition>(
  DEFAULT_ASSET_FILTER,
  resetAssetPaginationOnFilterChangeAtom,
);
